var map = {
	"./2013.png": 9153,
	"./2014.jpg": 650,
	"./2015.jpg": 8135,
	"./2016.jpg": 9736,
	"./2017.png": 8789,
	"./2018.png": 6786,
	"./2019.png": 5787,
	"./2021.jpg": 6662,
	"./2022.jpg": 4417,
	"./2023.jpg": 84,
	"./2024.png": 9263,
	"./2025.png": 7718,
	"./2025_2.png": 2745,
	"./2026.png": 8925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7748;